import { createSlice } from "@reduxjs/toolkit";

const webPhoneSlice = createSlice({
  name: "webPhone",
  initialState: {
    isInitialized: false,
    error: null,
    currentCallSid: null,
  },
  reducers: {
    setCurrentCallSid: (state, action) => {
      state.currentCallSid = action.payload;
    },
    setInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setCurrentCallStatus: (state, action) => {
      state.currentCallStatus = action.payload;
    },
  },
});

export const {
  setCurrentCallSid,
  setInitialized,
  setError,
  setCurrentCallStatus,
} = webPhoneSlice.actions;

export default webPhoneSlice.reducer;
